import React from "react";
import TitleHeader from "../../global/TitleHeader.jsx";
import { useParams } from "react-router-dom";
import { Industries, IndustryTitles } from "../../../MockData.jsx";
import NewsLetter from "../home/NewsLetter.jsx";

const IndustriesIndex = () => {
  const { industryName } = useParams();

  // Find the selected industry
  const selectedIndustry = Industries.find(
    (industry) => industry.slug === industryName.toLowerCase()
  );

  // Find the matching title description
  const industryTitle = IndustryTitles.find(
    (item) => item.slug === industryName.toLowerCase()
  )?.title;

  // Fallback if industry is not found
  if (!selectedIndustry) {
    return <div className="p-8 text-red-500">Industry not found.</div>;
  }

  return (
    <div>
      <TitleHeader
        title={selectedIndustry.category}
        description={industryTitle} // <- Pass dynamic title here
      />
      <div className="section-container ma:py-14 py-8 mx-auto">
        <div className="flax flax-col">
          {selectedIndustry.items.map((item, index) => (
            <div
            key={index}
            className="bg-white p-6 md:p-8 title-space"
          >
            {/* Title always on top in small screen */}
            <div className="text-2xl text-primary-200 font-bold text-center md:hidden">
              {item.title}
            </div>
          
            <div
              className={`flex flex-col ${
                index % 2 === 0 ? "md:flex-row-reverse" : "md:flex-row"
              } items-center justify-center gap-10`}
            >
              {/* Image */}
              <img
                src={`/assets/${item.img}`}
                alt="Industrial Work"
                className="rounded-full w-[450px] h-[500px] md:w-[400px] object-cover blurred-edges"
              />
          
              {/* Content */}
              <div className="max-w-xl flax-col title-space text-center md:text-left">
                <div>
                <p className="text-primary-100 md:block hidden tracking-wider">
                  {selectedIndustry.category}
                </p>
          
                {/* Title only on md+ */}
                <div className="hidden md:block text-3xl text-primary-200 md:text-4xl font-bold">
                  {item.title}
                </div>
                </div>
          
                <div className="italic text-text_color-100 font-medium">
                  {item.desc}
                </div>
              </div>
            </div>
          </div>
          
          ))}
        </div>
      </div>
      <NewsLetter />
    </div>
  );
};

export default IndustriesIndex;
